import api from '../../utils/api';

const url = 'gift-cards/';
const mailTrackingUrl = 'gift-cards/mailtracking';

export default {
  balance: (payload) => {
    const { partner: paymentProcessor, card: code, businessId } = payload;
    return api.makeEndpoint(
      'get',
      `${url}${paymentProcessor.toLowerCase()}/${code}?businessId=${businessId}`
    );
  },
  mailTracking: ({ giftCardConfigId, code }) =>
    api.makeEndpoint(
      'get',
      `${mailTrackingUrl}/${encodeURIComponent(giftCardConfigId)}/${encodeURIComponent(code)}`
    ),
  saveMailTracking: ({
    giftCardConfigId,
    code,
    trackingNumber,
    carrier,
    website,
  }) =>
    api.makeEndpoint(
      'post',
      `${mailTrackingUrl}/${encodeURIComponent(giftCardConfigId)}/${encodeURIComponent(code)}`
    )({
      data: {
        trackingNumber,
        carrier,
        website,
      },
    }),
};
